export { createAttributeBlockKey } from './createAttributeBlockKey'
export { isFreeTextContextValue } from './isFreeTextContextValue'
export { isValueInAttributeBlock } from './isValueInAttributeBlock'
export { getAttributeBlockLocators } from './getAttributeBlockLocators'

export const CONTEXT_LOGIC_CONDITION_PREFIX = '__context'
